import { useParams } from "react-router-dom";
import { DetailPageSections } from "../shared";
import { PersistentDiskListByEnvironment } from "../shared/persistent-disk";

export const EnvironmentPersistentDisksPage = () => {
  const { id = "" } = useParams();

  return (
    <div className="mb-4">
      <DetailPageSections>
        <PersistentDiskListByEnvironment envId={id} />
      </DetailPageSections>
    </div>
  );
};
